import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GiveawayItem } from '../../models/giveaway-item.model';
import { GiveawayItemTypeService } from '../../services/giveaway-item-type.service';
import { DisplayModes } from '../../../models/enums';
import { AppTranslationService } from '../../../services/app-translation.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'crm-save-giveaway-item-type',
  templateUrl: './save-giveaway-item-type.component.html',
  styleUrls: ['./save-giveaway-item-type.component.css']
})
export class SaveGiveawayItemTypeComponent implements OnInit {
  item: GiveawayItem = new GiveawayItem();
  displayMode: DisplayModes;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() itemId: number;
  giveawayItemTypes: any[] = [];
  constructor(private readonly giveawayItemTypeService: GiveawayItemTypeService,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService,
    private readonly route: ActivatedRoute,
    private readonly router: Router) { }

  ngOnInit() {
    this.displayMode = DisplayModes.Success;
    if (this.itemId != undefined)
      this.getDetails(this.itemId);

  }

  save(form) {
    if (!form.invalid) {

      this.displayMode = DisplayModes.Loading;
      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.giveawayItemTypeService.save(this.item).subscribe(response => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        if (this.item.id == 0)
          this.item = new GiveawayItem();
        else
          this.closeEvent.emit(true);

        this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
      }, err => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }


  back() {
    this.closeEvent.emit(true);
  }


  getDetails(id) {
    this.displayMode = DisplayModes.Loading;
    this.giveawayItemTypeService.getById(id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.item = response as GiveawayItem;
     
    }, err => {
      this.displayMode = DisplayModes.Error;

    });
  }


}
